import * as dataLayer from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { bool } from 'aws-sdk/clients/signer'

export const trackFaveNumbersChangeTab = (activeTab: string) =>
  trackEvent(dataLayer.keys.faveNumbersEvent, {
    interaction_type: 'Tab Change',
    activeTab,
  })

export const trackFaveNumbersSelectGame = (activeTab: string) =>
  trackEvent(dataLayer.keys.faveNumbersEvent, {
    interaction_type: 'Game Select',
    activeTab,
  })

export const trackFaveNumbersSaveNumbers = () =>
  trackEvent(dataLayer.keys.faveNumbersEvent, {
    interaction_type: 'Save Numbers',
  })

export const trackFaveNumbersDeleteNumbers = () =>
  trackEvent(dataLayer.keys.faveNumbersEvent, {
    interaction_type: 'Delete Numbers',
  })

export const trackFaveNumbersUsedSavedNumbers = (isActivating: bool) =>
  trackEvent(dataLayer.keys.faveNumbersEvent, {
    interaction_type: `Use Saved Numbers ${isActivating ? '(selected)' : '(deselected)'}`,
  })

export const trackFaveNumbersShowPools = () =>
  trackEvent(dataLayer.keys.faveNumbersEvent, {
    interaction_type: 'Show All Pools',
  })
